// extracted by mini-css-extract-plugin
export default {"link":"iK-z","disabled":"jK-z"};